import { Injectable } from '@angular/core';
import { TaskType } from '../enums/task.type';

@Injectable({ providedIn: 'root' })
export class TaskTypeHelper {
  public getTaskTypeName(tt?: number) {
    switch (tt) {
      case null:
      case undefined:
        return '';
      case TaskType.DrivenPlated:
      case TaskType.DrivenUninsured:
      case TaskType.DriverInsured:
      case TaskType.DrivenPrestige:
      case TaskType.DrivenEngineiusGo:
        return 'Driven';
      case TaskType.UncoveredTransportedMovement:
      case TaskType.CoveredTransportedMovement:
      case TaskType.PrestigeTransported:
        return 'Transported';
      case TaskType.RecoveredSkates:
      case TaskType.RecoveredFullLiftOnly:
      case TaskType.RecoveredMoreEquipmentNeeded:
        return 'Recovered';
      case TaskType.DrivenInsuredInspection:
      case TaskType.DrivenPlatedInspection:
        return 'Inspect & Collect';
      default:
        return '';
    }
  }
}
